import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Form } from 'antd';

// Shared UI Library Components
import {
  CustomIcon,
  CustomTooltip, EIconName,
  SwitchElement,
  UserAvatar
} from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './settings-option.scss';

// Store entities
import {
  updateCompanyPermissionSettings
} from '../../../../../../store/permission-settings/permission-settings.thunks';

// Models
import { ICompanyPermissionSettings } from '../../../../../../interfaces/permission-settings.interfaces';

type TSettingsOptionProps = {
  type: 'clients' | 'counsellors';
  company_permission_settings: ICompanyPermissionSettings;
};

export const SettingsOption: FC<TSettingsOptionProps> = (
  { type, company_permission_settings }: TSettingsOptionProps
) => {
  const [form] = Form.useForm<ICompanyPermissionSettings>();

  const dispatch = useDispatch<any>();

  const updatePermissionSettings = (settings: ICompanyPermissionSettings): void => {
    dispatch(updateCompanyPermissionSettings({
      is_worker_profile_edit_enabled: company_permission_settings.is_worker_profile_edit_enabled,
      // is_worker_availability_edit_enabled: company_permission_settings.is_worker_availability_edit_enabled,
      is_worker_rates_show_enabled: company_permission_settings.is_worker_rates_show_enabled,
      ...settings
    }));
  }

  const onValuesChange = (_: { [key in keyof ICompanyPermissionSettings]: boolean }, allValues: ICompanyPermissionSettings): void => {
    updatePermissionSettings(allValues);
  };

  useEffect(() => {
    if (type === 'clients') {
      form.setFieldsValue({
        is_anonymity_enabled: company_permission_settings.is_anonymity_enabled,
      });
      return;
    }
    form.setFieldsValue({
      is_worker_profile_edit_enabled: company_permission_settings.is_worker_profile_edit_enabled,
      // is_worker_availability_edit_enabled: !!company_permission_settings.is_worker_availability_edit_enabled,
      is_worker_rates_show_enabled: company_permission_settings.is_worker_rates_show_enabled,
    });
  }, [company_permission_settings]);

  return (
    <Form form={ form } onValuesChange={ onValuesChange } className="settings-option">
      <div className="settings-option--info">
        <UserAvatar sizeClass={ 'small' }
                    defaultUrl='/assets/images/counsellors-avatar.svg' avatarUrl={ '' }/> All
      </div>
      { type === 'clients' && <>
        <div className="settings-option--switch">
          <div className="switch--header">
            Anonimity <CustomTooltip title={ '' }>
            <CustomIcon size={ 'size-md' } name={ EIconName.Info }/>
          </CustomTooltip>
          </div>
          <Form.Item name={ 'is_anonymity_enabled' } valuePropName={ 'checked' }>
            <SwitchElement/>
          </Form.Item>
        </div>
        {/*<div className="settings-option--switch"/>*/ }
        <div className="settings-option--switch"/>
      </> }
      { type === 'counsellors' && <>
        {/*<div className="settings-option--switch">*/ }
        {/*  <div className="switch--header">*/ }
        {/*    Availability Editing <CustomTooltip title={ '' }>*/ }
        {/*    <CustomIcon size={ 'size-md' } name={ EIconName.Info }/>*/ }
        {/*  </CustomTooltip>*/ }
        {/*  </div>*/ }
        {/*  <Form.Item name={ 'is_worker_availability_edit_enabled' }*/ }
        {/*             valuePropName={ 'checked' }>*/ }
        {/*    <SwitchElement/>*/ }
        {/*  </Form.Item>*/ }
        {/*</div>*/ }
        <div className="settings-option--switch">
          <div className="switch--header">
            Personal Data Editing <CustomTooltip title={ '' }>
            <CustomIcon size={ 'size-md' } name={ EIconName.Info }/>
          </CustomTooltip>
          </div>
          <Form.Item name={ 'is_worker_profile_edit_enabled' }
                     valuePropName={ 'checked' }>
            <SwitchElement/>
          </Form.Item>
        </div>
        <div className="settings-option--switch">
          <div className="switch--header">
            Rates Viewing<CustomTooltip title={ '' }>
            <CustomIcon size={ 'size-md' } name={ EIconName.Info }/>
          </CustomTooltip>
          </div>
          <Form.Item name={ 'is_worker_rates_show_enabled' }
                     valuePropName={ 'checked' }>
            <SwitchElement/>
          </Form.Item>
        </div>
      </> }
    </Form>
  );
}
